<template>
  <div class="QueryContractItem mt_5" v-if="ready">
    <component
      :is="Base"
      v-for="(MC, index) in contractData.mc_prod_list"
      :key="'mc_' + index"
      :contractData="contractData"
      :MC="MC"
      :index="index"
      :isOperate="true"
    ></component>
  </div>
</template>

<script>
import mf_Mixin from "@/desktop/views/mf/mixin";
import Avatar from "@/desktop/components/Avatar";
import moment from "moment";
// 投資型基本資料輸入
import Base_Type1 from "./QueryContractItem_IV/Base_Type1"; //1-1定期繳VL
import Base_Type2 from "./QueryContractItem_IV/Base_Type2"; //1-2定期+超額VUL
import Base_Type3 from "./QueryContractItem_IV/Base_Type3"; //1-3躉繳VL
import Base_Type4 from "./QueryContractItem_IV/Base_Type4"; //1-4躉繳VA
import Base_Type5 from "./QueryContractItem_IV/Base_Type5"; //1-5彈性繳VA
import Base_Type6 from "./QueryContractItem_IV/Base_Type6"; //1-6定期+超額VA
import Base_Type7 from "./QueryContractItem_IV/Base_Type7"; //1-7定期+彈性繳VL
import Base_Type8 from "./QueryContractItem_IV/Base_Type8"; //1-8定期+彈性繳VA
export default {
  mixins: [mf_Mixin],
  props: ["contractData"],
  components: {
    Avatar,
    Base_Type1,
    Base_Type2,
    Base_Type3,
    Base_Type4,
    Base_Type5,
    Base_Type6,
    Base_Type7,
    Base_Type8,
  },
  data() {
    return {
      detailData: null,
      ready: false,
      Base: "",
    };
  },
  created() {
    this.init();
  },
  computed: {},
  methods: {
    moment,
    init() {
      switch (this.contractData.prem_type) {
        case "1":
          this.Base = "Base_Type1";
          break;
        case "2":
          this.Base = "Base_Type2";
          break;
        case "3":
          this.Base = "Base_Type3";
          break;
        case "4":
          this.Base = "Base_Type4";
          this.hasAnnuity = true;
          break;
        case "5":
          this.Base = "Base_Type5";
          this.hasAnnuity = true;
          break;
        case "6":
          this.Base = "Base_Type6";
          this.hasAnnuity = true;
          break;
        case "7":
          this.Base = "Base_Type7";
          break;
        case "8":
          this.Base = "Base_Type8";
          this.hasAnnuity = true;
          break;
      }
      this.$emit("isReady");
      this.ready = true;
      this.$forceUpdate();
      setTimeout(() => {
        this.registerHanlink();
      }, 50);
    },
  },
};
</script>

<style lang="scss">
.QueryContractItem {
  max-width: 904px;
  width: 100%;
  border-radius: 4px;
  border: solid 2px #a0a0f0;
  &__head {
    background-color: rgba(160, 160, 240, 0.2);
    border-bottom: solid 2px #a0a0f0;
    padding: 4px 15px;
    display: flex;
    align-items: center;
    font-size: 18px;
    font-weight: 700;
    &__date,
    &__insured {
      white-space: nowrap;
      flex-grow: 0;
    }
  }
}
</style>
